export default {
  index: "Home Page",
  self_service: "Self-Service",
  order_center: "Order Center",
  help_center: "Help",
  personal_center: 'Personal center',
  my_business:'My Business',
  user_business:'User Center',
  warm: "WarmTip",
  special_booth: "Special Booth Service",
  normal_booth: "Normal Booth Service",
  self_apply: "Self Apply",
  orinary: "Regular order",
  insurance: "Insurance Order",
  certificateOrder: "Certificate Order",
  notice: "Notice",
  check_pass: "Checkdrawing Pass",
  check_fail: "Checkdrawing Fail",
  modify_pwd: "Modify Password",
  modify_personal: "Modify Personal Infomation",
  log_out: "Sign out",
  hello: "Hello",
  company_bussiness: "Business",
  contact_us: "Contact Us",
  address: "ADD : No.99 Baima Ave., Lishui District, Nanjing, China",
  phone: "TEL : +86 57253555 / 57258228",
  email: "E-mail : info@js-aec.com",
  service_guide: "Service Guide",
  check_special: "Check Special Booth Drawings",
  fixed_fee: "Fixed fee payment",
  equipment_rent: "Equipment Rent",
  foregift_refund: "Foregift Refund",
  invoice: "Invoice",
  wechat: "WeChat Official Account",
  miniprogram: "WeChat Applet",
  operation_manual: "Operation manual",
  个人中心: "Personal center",
  修改个人资料: "Modify personal information",
  修改密码: "Change Password",
  第三方账户信息: "Third-party account information",
  昵称: "Nickname",
  邮箱: "Email",
  手机: "Mobile phone",
  旧密码: "Old password",
  新密码: "New password",
  确认密码: "Confirm password",
  解绑: "Untie",
  绑定其他账户: "Bind another account",
  微信: "WeChat",
  支付宝: "Alipay",
  两次输入密码不一致: "The passwords entered twice are inconsistent",

  oldpassword_label: "Old Password",
  newpassword_label: "New Password",
  confirmpassword_label: "Confrim New Password",
  title_pwd: "Modify Password",
  confirm_btn: "Confrim",
  return_btn: "Home Page",
  oldpassword_placeholder: "Please enter your old password",
  newpassword_placeholder: "Please enter your new password",
  confirmpassword_placeholder: "Please re-enter your new password",
  title_info: "Modify Personal Infomation",
  nickname_label: "Nick Name",
  email_label: "Email",
  mobile_label: "Mobile",
  nickname_placeholder: "please enter your nickname",
  email_placeholder: "please enter your email correctly",
  mobile_placeholder: "Please enter your mobile phone correctly.",

  QQ: "QQ",
  ALIPAY: "ALIPAY",

  管理后台: "Manage background",

  展览会主场运营服务: "FOR EXHIBITIONS",
  展览馆驻场服务: "FOR VENUES",
  活动与体育赛事服务: "FOR EVENTS",
  企业品牌服务: "FOR CORPORATES"
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/index.js